package com.neurobs.ccabserver.translationadmin.components.testupload.components

import com.neurobs.ccabserver.translationadmin.states.TestUploadStateGenerator
import com.neurobs.react.ReactElementFactory
import com.neurobs.react.semanticui.{UiButtonFactory, UiGridFactory, UiInputFactory, UiLoaderFactory, UiMessageFactory}
import org.scalajs.dom
import org.scalajs.dom.console
import slinky.core.{FunctionalComponent, SyntheticEvent, TagElement}
import slinky.core.annotations.react
import slinky.core.facade.Hooks.{useEffect, useState}
import slinky.core.facade.{React, ReactElement}
import slinky.web.html._

@react
object TestSaveInput {

  case class Props(enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    val testUploadState = TestUploadStateGenerator.accessState

    props.enclosingElement(
      Seq[ReactElement](
        UiGridFactory.Grid(
          VersionInput(
            UiGridFactory.GridColumn(_)("eight wide")
          ),
          CCABSaveButton(
            UiGridFactory.GridColumn(_)("eight wide")
          )
        )("middle aligned")
      )
    )

  }

}

@react
object VersionInput {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    val testUploadState = TestUploadStateGenerator.accessState

    val inputRef = testUploadState.versionInputRef


    testUploadState.productVersionState.value match {
      case Left(_) => null
      case Right(productVersionDataOpt) => productVersionDataOpt match {
        case None => null
        case Some(data) =>
          props.enclosingElement(
            Seq[ReactElement](
              ReactElementFactory.P(s"The most recent version of the CCAB in the database is ${data.version}"),
              UiInputFactory.TextInput(
                "CCAB Version",
                inputRef = inputRef
              )
            )
          )
      }
    }
  }
}

@react
object CCABSaveButton {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)

  val component = FunctionalComponent[Props] { props =>

    val testUploadState = TestUploadStateGenerator.accessState

    val (versionError, setVersionError) = useState[Option[String]](None)
    val (creatingCCAB, setCreatingCCAB) = useState(false)

    useEffect(() => {
      setCreatingCCAB(false)
    }, Vector(testUploadState.productVersionState.value))

    def handleSave: () => Unit = () => {
      setVersionError(None)
      testUploadState.productVersionState.value.map(_.map(data => {
        if (testUploadState.versionInputRef.current != null) {
          testUploadState.parseVersionString(testUploadState.versionInputRef.current.value) match {
            case None => setVersionError(Some("CCAB version must be a valid decimal"))
            case Some(decimal) =>
              if (decimal <= data.version) setVersionError(Some("CCAB version must be greater than most recent version"))
              else {
                testUploadState.ccabDiffState.value.map(ccabDiff => {
                  setCreatingCCAB(true)
                  testUploadState.createNewCCAB(decimal, data, ccabDiff)
                })
              }
          }
        }
      }))

    }
    props.enclosingElement(
      Seq[ReactElement](
        versionError match {
          case None => null
          case Some(error) => UiMessageFactory.BasicErrorMessage(error)
        },
        testUploadState.ccabDiffState.value match {
          case Left(_) =>
            UiButtonFactory.Button("Create new CCAB Version", handleClick = {() => {}})("disabled")
          case Right(_) =>
            UiButtonFactory.Button(
              "Create new CCAB Version",
              handleClick = handleSave
            )("primary")
        },
        if (creatingCCAB) UiLoaderFactory.ActiveTextLoader("Creating CCAB Version...")("mini")
        else null
      )
    )
  }
}
